var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-menu",
        {
          attrs: { left: "", disabled: !_vm.can("Override attendance") },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-chip",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "soli-round",
                          attrs: { small: "", outlined: "" },
                        },
                        "v-chip",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("div", { staticClass: "soli-grey caption" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.attendance.status ?? "Status") +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        { attrs: { right: "", small: "", color: "secondary" } },
                        [
                          _vm._v(
                            "\n                    arrow_drop_down_circle\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            _vm._l(_vm.options, function (option, idx) {
              return _c(
                "v-list-item",
                {
                  key: idx,
                  class: [
                    "soli-round",
                    _vm.attendance.status == option ? "soli-status-blue" : null,
                  ],
                  attrs: {
                    disabled:
                      !_vm.can("Override attendance") ||
                      (_vm.attendance.lesson.group_event_id &&
                        option == "Courtesy-cancel"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.adminUpdate(option, null)
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-title",
                    {
                      class:
                        _vm.attendance.status == option ? "white--text" : null,
                    },
                    [_vm._v(_vm._s(option))]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.confirmCredit
        ? _c(
            "SoliChoice",
            {
              attrs: {
                title: "Cancel-credit",
                subtitle: `Cancel-credited lessons are unable to be altered. What would you like to do?`,
                button1: "Confirm",
                button2: "Nevermind",
                disabled1: !_vm.creditSelection,
              },
              on: {
                reset: function ($event) {
                  _vm.closeModal(
                    () => (
                      (_vm.confirmCredit = false), (_vm.creditSelection = null)
                    )
                  )
                },
                option1: function ($event) {
                  return _vm.creditSelection.confirm()
                },
                "hook:mounted": function ($event) {
                  return _vm.getCreditPricing()
                },
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "v-container",
                    [
                      _c("v-select", {
                        attrs: {
                          items: [
                            {
                              text: "Update Attendance Only",
                              confirm: () =>
                                _vm.adminUpdate("Cancel-credit", false),
                            },
                            {
                              text: `Credit Account ${
                                _vm.creditPricing ?? "(loading...)"
                              }`,
                              confirm: () =>
                                _vm.adminUpdate("Cancel-credit", true),
                            },
                            {
                              text: `Convert to ${
                                _vm.attendance.lesson.group_event
                                  ? 30
                                  : _vm.attendance.lesson.duration
                              } minute Drop-in`,
                              hidden: !_vm.attendance.lesson.canConvertToPass,
                              confirm: () =>
                                _vm.adminUpdate("Cancel-credit", false, {
                                  name: "Drop-In Lessons",
                                  duration: _vm.attendance.lesson.group_event
                                    ? 30
                                    : _vm.attendance.lesson.duration,
                                }),
                            },
                            {
                              text: `Convert to Accelerated Lab Guest Pass`,
                              hidden:
                                !_vm.attendance.lesson.group_event
                                  ?.can_exchange_passes,
                              confirm: () =>
                                _vm.adminUpdate("Cancel-credit", false, {
                                  name: "Accelerated Lab Guest Pass",
                                  duration: 60,
                                }),
                            },
                            {
                              text: `Convert to Musicologie Junior Guest Pass`,
                              hidden:
                                _vm.attendance.lesson.group_event?.title !==
                                "Musicologie Junior",
                              confirm: () =>
                                _vm.adminUpdate("Cancel-credit", false, {
                                  name: "Junior Guest Pass",
                                  duration: 40,
                                }),
                            },
                          ].filter((e) => !e.hidden),
                          "item-text": "text",
                          "return-object": "",
                          "hide-details": "",
                          label: "Credit Options",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.creditSelection,
                          callback: function ($$v) {
                            _vm.creditSelection = $$v
                          },
                          expression: "creditSelection",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }